import {Add} from "@mui/icons-material";
import {Card, IconButton, Stack, Typography} from "@mui/material";
import {useState} from "react";
import {useAuthState} from "react-firebase-hooks/auth";
import {useList} from "react-firebase-hooks/database";
import {auth, createEstimationsHookQuery, EstimationModel} from "../../firebase/index.js";
import APXWebAppBackButton from "../../reusables/APXWebAppBackButton.jsx";
import {webappPaths} from "../../reusables/js/AppRoutes.js";
import {red_900} from "../../reusables/js/APXTheme.js";
import {nonPlusLimits, useInMemoryPlusStatus} from "../../reusables/plus/APXPlus.js";
import {APXPlusRequiredAlert} from "../../reusables/plus/APXPlusAlerts.jsx";
import AddNewEstimationBSL from "./AddNewEstimationBSL.jsx";
import EstimationLayout from "./EstimationLayout.jsx";
import {rowKeyEstimation} from "./EstimationUtil.js";


export default function EstimationFragment() {
	  
	  const [user] = useAuthState(auth);
	  const uid = /*TRUTHY->*/ !!user && user?.uid;
	  const [snapshots, loading, error] = useList(createEstimationsHookQuery(uid || ""));
	  
	  const [showAddEstimationBSL, setShowAddEstimationBSL] = useState(false);
	  
	  const {isPlusUser} = useInMemoryPlusStatus();
	  
	  return (
				 <>
						<APXWebAppBackButton webAppRoutePath={webappPaths.root}/>
						<Card variant={"outlined"} sx={{my: 8, borderColor: red_900}}>
							  <Stack direction={"row"} alignItems={"stretch"}>
									 <Stack direction={"row"} justifyContent={"center"} sx={{backgroundColor: red_900}}>
											
											<EstimationLayout forKeys={true} item={rowKeyEstimation}/>
									 
									 </Stack>
									 <Stack direction={"row"} sx={{width: "100%", overflowX: "auto", whiteSpace: "nowrap"}}>
											{/*NOT->*/ !loading && snapshots.length === 0 &&
													  <Typography p={2} variant="h4" alignContent={"center"} whiteSpace={"wrap"}>No estimations added</Typography>
											}
											{/*NOT->*/ !loading && /*TRUTHY->*/ !!snapshots &&
													  snapshots.map((snapshot) => {
															 const estimation = EstimationModel.fromObject(snapshot.val());
															 return <EstimationLayout key={estimation.estimationKey} item={estimation}/>;
													  })
											}
									 
									 </Stack>
									 <Stack justifyContent={"center"} sx={{py: 0, backgroundColor: red_900}}>
											<IconButton sx={{p: 0.5, color: "white"}} onClick={() => setShowAddEstimationBSL(true)}><Add/></IconButton>
											{
												  showAddEstimationBSL ?
															 (
																		(isPlusUser)
																		||
																		(/*NOT->*/ !isPlusUser && /*NOT->*/ !loading && /*TRUTHY->*/ !!snapshots && snapshots.length < nonPlusLimits.est.numerical)
															 ) ?
																		<AddNewEstimationBSL uid={uid} onClose={() => setShowAddEstimationBSL(false)} estimation={null}/>
																		:
																		<APXPlusRequiredAlert/>
															 : null
											}
									 </Stack>
							  </Stack>
						</Card>
				 </>
	  );
}